import { FSM, COMMON, EDC, SERVICEFLOW } from '../utils/constants.json';
import { TIME_PERIOD_LIST } from '../components/fseManagementSystem/components/TimePeriodSelector/utils';

const INITIAL_STATE = {
  type: 'self',
  previousStage: ['DASHBOARD'],
  currentStage: 'DASHBOARD',
  previousStageParams: null,
  headerState: 'My Targets',
  isNetworkAvailable: 'NETWORK_AVAILABLE',
  attendanceRecords: [],
  mapLoadFailure: false,
  teamTrackingDetailView: false,
  timePeriodList: TIME_PERIOD_LIST,
  appVersion: null,
  exitDetails: {},
};
/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case FSM.HOMEPAGE.SUCCESS:
      return { ...state, ...payload };
    case FSM.HOMEPAGE.FAILURE:
      return { ...state, ...payload };
    case FSM.TARGET.SUCCESS:
      return { ...state, ...payload };
    case FSM.TARGET.FAILURE:
      return { ...state, ...payload };
    case FSM.MAP.SUCCESS:
      return { ...state, ...payload };
    case FSM.MAP.FAILURE:
      return { ...state, ...payload };
    case FSM.MERCHANT.SUCCESS:
      return { ...state, ...payload };
    case FSM.MERCHANT.FAILURE:
      return { ...state, ...payload };
    case FSM.ATTENDANCE.SUCCESS:
      return { ...state, ...payload };
    case FSM.ATTENDANCE.FAILURE:
      return { ...state, ...payload };
    case FSM.LEAVE.SUCCESS:
      return { ...state, ...payload };
    case FSM.LEAVE.FAILURE:
      return { ...state, ...payload };
    case FSM.LEAVE_REASON.SUCCESS:
      return { ...state, ...payload };
    case FSM.LEAVE_REASON.FAILURE:
      return { ...state, ...payload };
    case FSM.REQUEST.SUCCESS:
      return { ...state, ...payload };
    case FSM.REQUEST.FAILURE:
      return { ...state, ...payload };
    case FSM.NETWORK.SUCCESS:
      return { ...state, ...payload };
    case FSM.LOCATION.SUCCESS:
      return { ...state, ...payload };
    case FSM.LOCATION.FAILURE:
      return { ...state, ...payload };
    case FSM.ATTENDANCE_RECORDS.SUCCESS:
      return { ...state, ...payload };
    case FSM.ATTENDANCE_RECORDS.FAILURE:
      return { ...state, ...payload };
    case FSM.GATE_MEETING.SUCCESS:
      return { ...state, ...payload };
    case FSM.GATE_MEETING.FAILURE:
      return { ...state, ...payload };
    case FSM.PSA.SUCCESS:
      return { ...state, ...payload };
    case FSM.PSA.FAILURE:
      return { ...state, ...payload };
    case FSM.REQUESTS.SUCCESS:
      return { ...state, ...payload };
    case FSM.REQUESTS.FAILURE:
      return { ...state, ...payload };
    case FSM.FILTERS.SUCCESS:
      return { ...state, ...payload };
    case FSM.FILTERS.FAILURE:
      return { ...state, ...payload };
    case FSM.SORTBY.SUCCESS:
      return { ...state, ...payload };
    case FSM.SORTBY.FAILURE:
      return { ...state, ...payload };
    case FSM.TAG.SUCCESS:
      return { ...state, ...payload };
    case FSM.TAG.FAILURE:
      return { ...state, ...payload };
    case FSM.PATH_TRACKING.SUCCESS:
      return { ...state, ...payload };
    case FSM.PATH_TRACKING.FAILURE:
      return { ...state, ...payload };
    case FSM.ADDRESS.SUCCESS:
      return { ...state, ...payload };
    case FSM.ADDRESS.FAILURE:
      return { ...state, ...payload };
    case FSM.P4B_USER.SUCCESS:
      return { ...state, ...payload };
    case FSM.P4B_USER.FAILURE:
      return { ...state, ...payload };
    case FSM.ZONE.SUCCESS:
      return { ...state, ...payload };
    case FSM.ZONE.FAILURE:
      return { ...state, ...payload };
    case EDC.EDC_PANEL.SUCCESS:
      return { ...state, ...payload };
    case EDC.EDC_PANEL.FAILURE:
      return { ...state, ...payload };
    case FSM.DMS.SUCCESS:
      return { ...state, ...payload };
    case FSM.DMS.FAILURE:
      return { ...state, ...payload };
    case FSM.HIERARCHY_DATA.SUCCESS:
      return { ...state, ...payload };
    case FSM.HIERARCHY_DATA.FAILURE:
      return { ...state, ...payload };
    case FSM.EXIT_DETAILS.SUCCESS:
      return { ...state, ...payload };
    case FSM.EXIT_DETAILS.FAILURE:
      return { ...state, ...payload };
    case COMMON.CLEAR.FSM:
      return {
        ...INITIAL_STATE,
        type: state.type,
        target: state.target,
        currentStage: state.currentStage,
        previousStage: state.previousStage,
        previousStageParams: state.previousStageParams,
      };
    case SERVICEFLOW.MERCHANT_TO_SERVICEFLOW:
      return { ...state, ...payload };
    case FSM.APP_VERSION:
      return { ...state, ...payload };
    default:
      return { ...state };
  }
}
